<template>
    <div class="repCharac">
        <div class="titlePage">Reportes de Caracterización</div>
        <va-notification v-if="noDtaForm" color="danger" class="refNoData">No se encuentran formularios en este momento.</va-notification>
        <div class="listData" v-if="!noDtaForm">
            <DataList
                :InfoView="this.DLDataList"
                :HeadTable="this.HDDataList"
                Report=""
                v-if="renderComponent1"
            />
        </div>
    </div>
</template>

<script>
import IberoHelpers from '@/store/helpers.js'
import DataList from '@/components/data-tables/DataListCharact.vue'

export default {
  name: 'repCharac',
  components: {
    DataList,
  },
  data () {
    return {
      renderComponent1: false,
      HDDataList: [
        {
          name: 'IdCharacterization',
          title: 'Id',
          width: '10%',
        },
        {
          name: 'NamCharacterization',
          title: 'Nombre',
          width: '40%',
        },
        {
          name: '__slot:dateCretedIni',
          title: 'Fecha Inicio',
          dataClass: 'text-left',
          width: '20%',
        },
        {
          name: '__slot:dateCretedFin',
          title: 'Fecha Fin',
          dataClass: 'text-left',
          width: '20%',
        },
        {
          name: '__slot:status',
          title: 'Activo',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: '__slot:viewHistory',
          title: 'Historico',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
          actionRef: [
            {
              label: 'Editar',
              icon: 'fa-pencil',
              action: 'show',
            },
          ],
        },
      ],
      DLDataList: [],
      noDtaForm: false,
    }
  },
  created: function () {
    let loader = this.$loading.show()
    var listCaract = IberoHelpers.getListCaracterizacion(this.$store, 5)
    listCaract.then(Response => {
      if (Response.data === '') {
        this.noDtaForm = true
      } else {
        this.DLDataList = Response.data.Characterizations
        this.noDtaForm = false
        IberoHelpers.forceRerender1(this)
      }
      loader.hide()
    })
  },
}
</script>